import React from "react";

import styles from "./p.module.scss"

const P = (props) =>  (
  <p {...props} className={`${styles.root} ${props.className} ${styles[props.color]}`} />
)

P.defaultProps = {
  className: '',
  color: 'lightGrey'
}

export default P;
